import { useState } from "react";
import { Box, Tooltip, IconButton } from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import BuyBoxModal from "./BuyBoxModal";

// Estados de MELI (catalog_item_competition_status / price_to_win) en los que la
// publicación está PERDIENDO el Buy Box. Solo en estos casos mostramos la alerta:
//  - competing: pierde frente a otra publicación.
//  - listed: no compite (incumple alguna condición); igual está en desventaja.
// winning / sharing_first_place NO muestran nada (no hay pérdida).
export const LOSING_STATUSES = ["competing", "listed"];

// Predicado ÚNICO que comparten el indicador y el filtro "Flags Meli": hay OTRO
// vendedor vinculado al catálogo (catalogFlag) Y además se está perdiendo el Buy Box
// (status competing/listed). Sin competidor de catálogo no se considera pérdida.
export function isLosingBuyBox(competition, catalogFlag) {
  return (
    !!catalogFlag &&
    !!competition &&
    LOSING_STATUSES.includes(competition.status)
  );
}

// Indicador reutilizable (Deals y Pricing): ⚠️ + tooltip por estado; al click abre
// el modal con la comparación ganadora vs propia. `competition` es el objeto
// catalog_competition(_c); `title` es el texto a mostrar en el encabezado del modal.
// `catalogFlag` = hay OTRO vendedor vinculado al catálogo (row.catalogflag).
export default function BuyBoxAlert({ competition, title, catalogFlag = false }) {
  const [open, setOpen] = useState(false);

  if (!isLosingBuyBox(competition, catalogFlag)) return null;

  const tooltip =
    competition.status === "listed"
      ? "Esta publicación no está compitiendo por el Buy Box. Click para ver el detalle."
      : "Estás perdiendo el Buy Box frente a otra publicación. Click para ver el detalle.";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <Tooltip title={tooltip} arrow>
        <IconButton
          size="small"
          aria-label="Alerta de Buy Box"
          onClick={(e) => {
            e.stopPropagation();
            setOpen(true);
          }}
        >
          <WarningAmberRoundedIcon sx={{ fontSize: 20, color: "#D32F2F" }} />
        </IconButton>
      </Tooltip>
      <BuyBoxModal
        open={open}
        onClose={() => setOpen(false)}
        competition={competition}
        title={title}
      />
    </Box>
  );
}
